function detectBrand() {
  // 1. Explicit query parameter (?brand=clash, ?brand=pints, ?brand=adult, etc.)
  var params = new URLSearchParams(window.location.search);
  var brandParam = (params.get('brand') || params.get('game') || params.get('logo') || '').toLowerCase();
  if (brandParam === 'clash' || brandParam === 'cribbage-clash') return 'clash';
  if (brandParam === 'pints' || brandParam === 'pints-and-pegs' || brandParam === 'cribbage-pints') return 'pints';
  if (brandParam === 'adult' || brandParam === 'stripped' || brandParam === 'skunked-and-stripped') return 'adult';
  if (brandParam === 'crazy' || brandParam === 'crazy-cribbage') return 'crazy';

  // 2. Direct page URL match
  var currentUrl = (window.location.href || '').toLowerCase();
  if (currentUrl.indexOf('game-cribbage-clash') !== -1 || currentUrl.indexOf('cribbage-clash') !== -1) {
    return 'clash';
  }
  if (currentUrl.indexOf('game-pints-and-pegs') !== -1 || currentUrl.indexOf('pints-and-pegs') !== -1 || currentUrl.indexOf('pints') !== -1) {
    return 'pints';
  }
  if (currentUrl.indexOf('game-skunked-and-stripped') !== -1 || currentUrl.indexOf('skunked-and-stripped') !== -1 || currentUrl.indexOf('adult') !== -1 || currentUrl.indexOf('stripped') !== -1) {
    return 'adult';
  }
  if (currentUrl.indexOf('game-crazy-cribbage') !== -1 || currentUrl.indexOf('crazy-cribbage') !== -1) {
    return 'crazy';
  }

  // 3. Parent frame check (if embedded in an iframe on Shopify)
  try {
    if (window.parent && window.parent !== window && window.parent.location.href) {
      var parentUrl = (window.parent.location.href || '').toLowerCase();
      if (parentUrl.indexOf('game-cribbage-clash') !== -1 || parentUrl.indexOf('cribbage-clash') !== -1) {
        return 'clash';
      }
      if (parentUrl.indexOf('game-pints-and-pegs') !== -1 || parentUrl.indexOf('pints-and-pegs') !== -1 || parentUrl.indexOf('pints') !== -1) {
        return 'pints';
      }
      if (parentUrl.indexOf('game-skunked-and-stripped') !== -1 || parentUrl.indexOf('skunked-and-stripped') !== -1 || parentUrl.indexOf('adult') !== -1 || parentUrl.indexOf('stripped') !== -1) {
        return 'adult';
      }
      if (parentUrl.indexOf('game-crazy-cribbage') !== -1 || parentUrl.indexOf('crazy-cribbage') !== -1) {
        return 'crazy';
      }
    }
  } catch (e) {}

  // 4. Referrer check (if embedded in cross-origin iframe from Shopify page)
  var ref = (document.referrer || '').toLowerCase();
  if (ref.indexOf('game-cribbage-clash') !== -1 || ref.indexOf('cribbage-clash') !== -1) {
    return 'clash';
  }
  if (ref.indexOf('game-pints-and-pegs') !== -1 || ref.indexOf('pints-and-pegs') !== -1 || ref.indexOf('pints') !== -1) {
    return 'pints';
  }
  if (ref.indexOf('game-skunked-and-stripped') !== -1 || ref.indexOf('skunked-and-stripped') !== -1 || ref.indexOf('adult') !== -1 || ref.indexOf('stripped') !== -1) {
    return 'adult';
  }
  if (ref.indexOf('game-crazy-cribbage') !== -1 || ref.indexOf('crazy-cribbage') !== -1) {
    return 'crazy';
  }

  // 5. Keyword fallback
  if (currentUrl.indexOf('clash') !== -1) return 'clash';
  if (currentUrl.indexOf('pints') !== -1) return 'pints';
  if (currentUrl.indexOf('adult') !== -1 || currentUrl.indexOf('stripped') !== -1) return 'adult';

  return 'crazy';
}

(function initDynamicLogo() {
  try {
    var logoEl = document.getElementById('menuLogo');
    if (!logoEl) return;
    var LOGOS = {
      crazy: {
        src: 'https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo_-_640_x_640.webp',
        alt: 'Crazy Cribbage'
      },
      clash: {
        src: 'https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-round-online-game-640x640.webp',
        alt: 'Cribbage Clash'
      },
      pints: {
        src: 'https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-pints-and-pegs_640x640_f004d2b4-49df-4181-a6d2-11c7f9212645.webp',
        alt: 'Pints and Pegs'
      },
      adult: {
        src: "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-skunked-and-stripped_-_640_x_640.webp?v=1791397387",
        alt: 'Skunked and Stripped'
      }
    };

    window.setLogoBrand = function(brand) {
      var chosen = LOGOS[brand] || LOGOS.crazy;
      var el = document.getElementById('menuLogo');
      var gamePlayLogo = document.getElementById('gamePlayLogo');
      if (el) {
        el.src = chosen.src;
        el.alt = chosen.alt;
      }
      if (gamePlayLogo) {
        gamePlayLogo.src = chosen.src;
        gamePlayLogo.alt = chosen.alt;
      }
      window.currentLogoBrand = brand;
      window.currentBrand = brand;

      var TITLES = {
        crazy: 'Free Cribbage Game — Play Crazy Cribbage Online Free, Person to Person or Against the Computer',
        clash: 'Cribbage Clash — Free 481-Hole Online Cribbage Battle Game',
        pints: 'Pints & Pegs — Free Pub Cribbage Game Online (Person to Person or vs Computer)',
        adult: 'Skunked and Stripped — Free Adult Cribbage Game Online'
      };
      if (typeof document !== 'undefined') {
        document.title = TITLES[brand] || TITLES.crazy;
        var metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
          var DESCS = {
            crazy: 'Play 100% free cribbage online! Play person to person locally or in online multiplayer rooms, or play against the computer AI. Featuring Crazy Cribbage, Cribbage Clash, Pints and Pegs, and adult modes. No download or registration required!',
            clash: 'Play Cribbage Clash 100% free online! Race across a 481-hole circular track with interactive traps, jumps, and obstacles. Person to person or vs computer.',
            pints: 'Play Pints & Pegs 100% free pub cribbage online! Classic cribbage strategy combined with spirited pub drinking spaces. Person to person or vs computer.',
            adult: 'Play Skunked and Stripped 100% free adult cribbage online! Strip-themed spaces, interactive timers, and adult challenges. Person to person or vs computer.'
          };
          metaDesc.setAttribute('content', DESCS[brand] || DESCS.crazy);
        }
      }

      var isClash = brand === 'clash';
      var isPints = brand === 'pints';
      var isAdult = brand === 'adult';
      document.documentElement.setAttribute('data-brand', brand);
      if (isClash) {
        document.documentElement.setAttribute('data-theme', 'rustic');
        if (document.body) document.body.setAttribute('data-theme', 'rustic');
        var appEl = document.getElementById('app');
        if (appEl) appEl.setAttribute('data-theme', 'rustic');
        var btnThemeMenu = document.getElementById('btnThemeMenu');
        if (btnThemeMenu) btnThemeMenu.style.display = 'none';
      } else if (isAdult) {
        var savedAdultTheme = 'passion';
        try {
          var s = (typeof window !== 'undefined' && window.appStorage) || (typeof localStorage !== 'undefined' ? localStorage : null);
          savedAdultTheme = (s ? s.getItem('skunkedAndStripped.theme') : null) || 'passion';
        } catch (e) {}
        document.documentElement.setAttribute('data-theme', savedAdultTheme);
        if (document.body) document.body.setAttribute('data-theme', savedAdultTheme);
        var appEl = document.getElementById('app');
        if (appEl) appEl.setAttribute('data-theme', savedAdultTheme);
        var btnThemeMenu = document.getElementById('btnThemeMenu');
        if (btnThemeMenu) btnThemeMenu.style.display = '';
      } else {
        var savedCrazyTheme = 'tournament';
        try {
          var s = (typeof window !== 'undefined' && window.appStorage) || (typeof localStorage !== 'undefined' ? localStorage : null);
          savedCrazyTheme = (s ? s.getItem('crazyCribbage.theme') : null) || 'tournament';
        } catch (e) {}
        document.documentElement.setAttribute('data-theme', savedCrazyTheme);
        if (document.body) document.body.setAttribute('data-theme', savedCrazyTheme);
        var appEl = document.getElementById('app');
        if (appEl) appEl.setAttribute('data-theme', savedCrazyTheme);
        var btnThemeMenu = document.getElementById('btnThemeMenu');
        if (btnThemeMenu) btnThemeMenu.style.display = '';
      }

      var btnShopMenuEl = document.getElementById('btnShopMenu');
      var btnShopHeaderEl = document.getElementById('btnShopHeader');
      if (btnShopMenuEl) btnShopMenuEl.style.display = isClash ? 'inline-flex' : 'none';
      if (btnShopHeaderEl) btnShopHeaderEl.style.display = isClash ? 'inline-flex' : 'none';

      var isCrazy = brand === 'crazy';
      var btnTourneyLaunch = document.getElementById('btnLaunchTourney');
      if (btnTourneyLaunch) btnTourneyLaunch.style.display = isCrazy ? 'inline-flex' : 'none';
      var btnModeTourney = document.getElementById('btnModeTourney');
      if (btnModeTourney) btnModeTourney.style.display = isCrazy ? 'inline-flex' : 'none';

      var orbitAngles = isClash
        ? {
            btnStart: '-75deg',
            btnJoinMenu: '-58deg',
            btnSettingsMenu: '-41deg',
            btnVariantsMenu: '-24deg',
            btnShopMenu: '-8deg',
            btnRecords: '8deg',
            btnShareMenu: '24deg',
            btnContactMenu: '41deg',
            btnHelp: '58deg',
            brandDropdownWrap: '75deg',
            btnBrandMenu: '75deg'
          }
        : {
            btnStart: '-75deg',
            btnJoinMenu: '-58deg',
            btnSettingsMenu: '-41deg',
            btnVariantsMenu: '-24deg',
            btnThemeMenu: '-8deg',
            btnRecords: '8deg',
            btnShareMenu: '24deg',
            btnContactMenu: '41deg',
            btnHelp: '58deg',
            brandDropdownWrap: '75deg',
            btnBrandMenu: '75deg'
          };
      for (var btnId in orbitAngles) {
        var orbitEl = document.getElementById(btnId);
        if (orbitEl) orbitEl.style.setProperty('--orbit-angle', orbitAngles[btnId]);
      }

      var optGoalWrap = document.getElementById('optGoalWrap') || (document.getElementById('optGoal') && document.getElementById('optGoal').closest('.opt'));
      var optGoalEl = document.getElementById('optGoal');
      if (optGoalWrap) optGoalWrap.style.display = isClash ? 'none' : '';
      if (isClash && optGoalEl) optGoalEl.value = 'high';

      function updateTargetDropdown(b) {
        var optTarget = document.getElementById('optTarget');
        if (!optTarget) return;
        var isClash = b === 'clash';
        var isCrazy = !b || b === 'crazy';
        var targetOptions = isClash
          ? [
              { value: '481', text: '481 points (Standard Match)' },
              { value: '361', text: '361 points (Short Match)' },
              { value: '241', text: '241 points (Mini Match)' }
            ]
          : (isCrazy
              ? [
                  { value: '121', text: 'Full Game (121)' },
                  { value: '61', text: 'Quick game (61)' },
                  { value: '31', text: 'Pegging Only (31)' },
                  { value: '241', text: '241 points (There and Back)' }
                ]
              : [
                  { value: '121', text: 'Full Game (121)' },
                  { value: '61', text: 'Quick game (61)' },
                  { value: '31', text: 'Pegging Only (31)' }
                ]);

        var currentVal = optTarget.value;
        var hasCurrent = targetOptions.some(function(o) { return o.value === currentVal; });
        var nextVal = hasCurrent ? currentVal : (isClash ? '481' : '121');

        optTarget.innerHTML = targetOptions
          .map(function(o) { return '<option value="' + o.value + '">' + o.text + '</option>'; })
          .join('');

        optTarget.value = nextVal;
        if (window.settings) {
          window.settings.target = parseInt(nextVal, 10);
        }
      }
      updateTargetDropdown(brand);
      if (!document.getElementById('optTarget')) {
        document.addEventListener('DOMContentLoaded', function() {
          updateTargetDropdown(window.currentBrand || brand);
        });
      }

      function syncBrandSettingsUI(b) {
        var container = document.getElementById('brand-game-options');
        var engine = (typeof window !== 'undefined' && window.GameOptionsEngine) ? window.GameOptionsEngine : null;
        if (container && engine && typeof engine.buildBrandSettingsUI === 'function') {
          if (container.getAttribute('data-rendered-brand') !== b) {
            engine.buildBrandSettingsUI(b, container);
            container.setAttribute('data-rendered-brand', b);
          }
        }
      }
      syncBrandSettingsUI(brand);
      var disableOtherFn = (window.CrazyCribbage && window.CrazyCribbage.LobbyController && window.CrazyCribbage.LobbyController.disableOtherGameBonusOptions) ||
                           (window.LobbyController && window.LobbyController.disableOtherGameBonusOptions);
      if (typeof disableOtherFn === 'function') {
        disableOtherFn(brand, window.settings || {});
      }
      function updateCpuAvailability(b) {
        var isNoCpu = b === 'pints' || b === 'adult';
        var oppEl = document.getElementById('optOpp');
        if (oppEl) {
          var cpuOpt = oppEl.querySelector('option[value="cpu"]');
          if (cpuOpt) {
            cpuOpt.disabled = isNoCpu;
            cpuOpt.hidden = isNoCpu;
            cpuOpt.style.display = isNoCpu ? 'none' : '';
          }
          if (isNoCpu && oppEl.value === 'cpu') {
            oppEl.value = 'online';
          }
        }
        var btnVsCpu = document.getElementById('btnModeVsCpu');
        if (btnVsCpu) {
          btnVsCpu.disabled = isNoCpu;
          btnVsCpu.hidden = isNoCpu;
          btnVsCpu.style.display = isNoCpu ? 'none' : '';
          if (isNoCpu && btnVsCpu.classList.contains('active')) {
            btnVsCpu.classList.remove('active');
            var btnOnline = document.getElementById('btnModeOnline');
            if (btnOnline) btnOnline.classList.add('active');
          }
        }
        var aiRow = document.getElementById('optAiProfileRow');
        if (aiRow) {
          if (isNoCpu) {
            aiRow.classList.add('hidden');
            aiRow.style.display = 'none';
          } else {
            var pCountEl = document.getElementById('optPlayerCount');
            var isTwoPlayer = !pCountEl || pCountEl.value === '2';
            var isCpu = oppEl && oppEl.value === 'cpu' && isTwoPlayer;
            aiRow.classList.toggle('hidden', !isCpu);
            aiRow.style.display = isCpu ? '' : 'none';
          }
        }
      }
      updateCpuAvailability(brand);
      if (!document.getElementById('optOpp')) {
        document.addEventListener('DOMContentLoaded', function() {
          updateCpuAvailability(window.currentBrand || brand);
        });
      }

      if (typeof applyBrandVisibility === 'function') {
        applyBrandVisibility(brand);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          if (typeof applyBrandVisibility === 'function') {
            applyBrandVisibility(window.currentBrand || brand);
          }
        });
      }

      if (typeof applyFormSettings === 'function' && typeof loadSettingsStore === 'function') {
        applyFormSettings(loadSettingsStore());
        if (typeof syncPlayerCountUi === 'function') syncPlayerCountUi();
        if (typeof renderRecordBox === 'function') renderRecordBox();
      }

      var updateButton = function() {
        var startText = document.querySelector('#btnStart .menu-orbit-label-text textPath');
        var startBtn = document.getElementById('btnStart');
        var variantsText = document.querySelector('#btnVariantsMenu .menu-orbit-label-text textPath');
        var variantsBtn = document.getElementById('btnVariantsMenu');
        var variantsModalTitle = document.getElementById('menuVariantsTitle');
        var gameTitleEl = document.getElementById('gameHeaderTitle') || document.querySelector('.header-title-wrap h1');
        var gamePlayLogo = document.getElementById('gamePlayLogo');

        var modalTitle = document.getElementById('startGameModalTitle');
        var modalBadge = document.getElementById('startGameModalBadge');
        var modalStartBtn = document.getElementById('btnConfirmStartGameText');

        if (brand === 'clash') {
          document.title = 'Cribbage Clash';
          if (startText) startText.textContent = 'BEGIN BATTLE';
          if (startBtn) {
            startBtn.setAttribute('aria-label', 'Begin Battle');
            startBtn.setAttribute('title', 'Begin Battle');
          }
          if (variantsText) variantsText.textContent = 'BOARD LAYOUT';
          if (variantsBtn) {
            variantsBtn.setAttribute('aria-label', 'Board Layout');
            variantsBtn.setAttribute('title', 'Board Layout');
          }
          if (variantsModalTitle) {
            variantsModalTitle.textContent = 'Board Layout';
            variantsModalTitle.style.cursor = 'pointer';
            variantsModalTitle.title = 'Open Track Sandbox';
            variantsModalTitle.onclick = function() {
              if (typeof window.openClashSandbox === 'function') {
                window.openClashSandbox({ brand: 'clash' });
              } else if (window.ClashSandboxModal && typeof window.ClashSandboxModal.open === 'function') {
                window.ClashSandboxModal.open({ brand: 'clash' });
              }
            };
          }
          if (gameTitleEl) gameTitleEl.textContent = 'CRIBBAGE CLASH';
          if (modalTitle) modalTitle.textContent = 'Cribbage Clash';
          if (modalBadge) modalBadge.textContent = '⚔️ BATTLE SETUP';
          if (modalStartBtn) modalStartBtn.textContent = 'BEGIN BATTLE';
          if (gamePlayLogo) {
            gamePlayLogo.src = "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-round-online-game-640x640.webp";
            gamePlayLogo.alt = "Cribbage Clash";
          }
        } else if (brand === 'pints') {
          document.title = 'Pints and Pegs';
          if (startText) startText.textContent = 'PLAY PINTS';
          if (startBtn) {
            startBtn.setAttribute('aria-label', 'Play Pints');
            startBtn.setAttribute('title', 'Play Pints');
          }
          if (variantsText) variantsText.textContent = 'BOARD LAYOUT';
          if (variantsBtn) {
            variantsBtn.setAttribute('aria-label', 'Board Layout');
            variantsBtn.setAttribute('title', 'Board Layout');
          }
          if (variantsModalTitle) {
            variantsModalTitle.textContent = 'Board Layout';
            variantsModalTitle.style.cursor = 'pointer';
            variantsModalTitle.title = 'Open Drinking Sandbox';
            variantsModalTitle.onclick = function() {
              if (typeof window.openPintsSandbox === 'function') {
                window.openPintsSandbox({ brand: 'pints' });
              } else if (window.ClashSandboxModal && typeof window.ClashSandboxModal.open === 'function') {
                window.ClashSandboxModal.open({ brand: 'pints' });
              }
            };
          }
          if (gameTitleEl) gameTitleEl.textContent = 'PINTS AND PEGS';
          if (modalTitle) modalTitle.textContent = 'Pints & Pegs';
          if (modalBadge) modalBadge.textContent = '🍺 PUB SETUP';
          if (modalStartBtn) modalStartBtn.textContent = 'PLAY PINTS';
          if (gamePlayLogo) {
            gamePlayLogo.src = "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-pints-and-pegs_640x640_f004d2b4-49df-4181-a6d2-11c7f9212645.webp";
            gamePlayLogo.alt = "Pints and Pegs";
          }
        } else if (brand === 'adult') {
          document.title = 'Skunked and Stripped';
          if (startText) startText.textContent = 'GET STRIPPED';
          if (startBtn) {
            startBtn.setAttribute('aria-label', 'Get Stripped');
            startBtn.setAttribute('title', 'Get Stripped');
          }
          if (variantsText) variantsText.textContent = 'BOARD LAYOUT';
          if (variantsBtn) {
            variantsBtn.setAttribute('aria-label', 'Board Layout');
            variantsBtn.setAttribute('title', 'Board Layout');
          }
          if (variantsModalTitle) {
            variantsModalTitle.textContent = 'Board Layout';
            variantsModalTitle.style.cursor = 'pointer';
            variantsModalTitle.title = 'Open Adult Sandbox';
            variantsModalTitle.onclick = function() {
              if (typeof window.openAdultSandbox === 'function') {
                window.openAdultSandbox({ brand: 'adult' });
              } else if (window.ClashSandboxModal && typeof window.ClashSandboxModal.open === 'function') {
                window.ClashSandboxModal.open({ brand: 'adult' });
              }
            };
          }
          if (gameTitleEl) gameTitleEl.textContent = 'SKUNKED AND STRIPPED';
          if (modalTitle) modalTitle.textContent = 'Skunked & Stripped';
          if (modalBadge) modalBadge.textContent = '🔥 INTIMATE SETUP';
          if (modalStartBtn) modalStartBtn.textContent = 'PLAY SKUNKED';
          if (gamePlayLogo) {
              gamePlayLogo.src = "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo-skunked-and-stripped_-_640_x_640.webp?v=1791397387";
            gamePlayLogo.alt = "Skunked and Stripped";
          }
        } else if (brand === 'crazy') {
          document.title = 'Crazy Cribbage';
          if (startText) startText.textContent = 'GO CRAZY';
          if (startBtn) {
            startBtn.setAttribute('aria-label', 'Start Game');
            startBtn.setAttribute('title', 'Start Game');
          }
          if (variantsText) variantsText.textContent = 'CRAZY VARIANTS';
          if (variantsBtn) {
            variantsBtn.setAttribute('aria-label', 'Crazy Variants');
            variantsBtn.setAttribute('title', 'Crazy Variants');
          }
          if (variantsModalTitle) {
            variantsModalTitle.textContent = 'Crazy Variants';
            variantsModalTitle.style.cursor = '';
            variantsModalTitle.title = '';
            variantsModalTitle.onclick = null;
          }
          if (gameTitleEl) gameTitleEl.textContent = 'CRAZY CRIBBAGE';
          if (modalTitle) modalTitle.textContent = 'Crazy Cribbage';
          if (modalBadge) modalBadge.textContent = '🎮 QUICK SETUP';
          if (modalStartBtn) modalStartBtn.textContent = 'START GAME';
          if (gamePlayLogo) {
            gamePlayLogo.src = "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/logo_-_640_x_640.webp";
            gamePlayLogo.alt = "Crazy Cribbage";
          }
        }
      };

      updateButton();
      if (!document.getElementById('btnStart') || !document.getElementById('gameHeaderTitle')) {
        document.addEventListener('DOMContentLoaded', updateButton);
      }

      if (brand === 'clash') {
        if (window.settings && (!window.settings.target || [121, 61, 31].indexOf(Number(window.settings.target)) !== -1)) {
          window.settings.target = 481;
        }
      } else if (brand === 'pints') {
        if (window.settings) {
          window.settings.brand = 'pints';
          if (!window.settings.target || [241, 361, 481].indexOf(Number(window.settings.target)) !== -1) {
            window.settings.target = 121;
          }
          if (window.settings.selected3DBoardId === 'board-cribbage-clash' || window.settings.selected3DBoardId === 'board-cribbage-clash-square') {
            window.settings.selected3DBoardId = 'board-14';
          }
        }
        var optTargetEl = document.getElementById('optTarget');
        if (optTargetEl && [241, 361, 481].indexOf(Number(optTargetEl.value)) !== -1) {
          optTargetEl.value = '121';
        }
        var bClashEl = document.getElementById('cribbage-clash-options');
        if (bClashEl) bClashEl.style.display = 'none';

        if (typeof disableOtherFn === 'function') {
          disableOtherFn('pints', window.settings || {});
        }

        var hasPintsActive = window.settings && (
          window.settings.optYouDrink || window.settings.optGuysDrink || window.settings.optGalsDrink ||
          window.settings.optLeftDrink || window.settings.optRightDrink || window.settings.optEveryoneDrink ||
          window.settings.optEveryoneButYouDrink || window.settings.optPickWhoDrinks
        );
        if (!hasPintsActive) {
          if (typeof window.applyPintsPreset === 'function') {
            try { window.applyPintsPreset('standard'); } catch (_) {}
          } else if (window.PintsPresets && typeof window.PintsPresets.applyPreset === 'function') {
            try { window.PintsPresets.applyPreset('standard'); } catch (_) {}
          }
        }
      }
      if (typeof window.updateBrandDropdownActive === 'function') {
        window.updateBrandDropdownActive(brand);
      }

      var buildBoardFn = window.buildBoard || (window.crazyCribbageApp && window.crazyCribbageApp.buildBoard);
      if (typeof buildBoardFn === 'function') {
        try { buildBoardFn(); } catch (e) {}
      }

      var checkAgeGate = window.checkInitialAgeGate || (window.crazyCribbageApp && window.crazyCribbageApp.checkInitialAgeGate);
      if (typeof checkAgeGate === 'function') {
        try { checkAgeGate(); } catch (e) {}
      } else if (typeof window.isAgeVerified === 'function' && typeof window.showAgeGateModal === 'function') {
        try {
          if (!window.isAgeVerified(brand)) {
            window.showAgeGateModal(brand);
          }
        } catch (e) {}
      }

      // Ensure global profile username and avatar UI stay in sync across brands
      try {
        var profileClass = window.Profile || (window.CrazyCribbage && window.CrazyCribbage.Profile);
        var profileInst = profileClass && typeof profileClass.getInstance === 'function' ? profileClass.getInstance() : null;
        var pName = profileInst ? profileInst.getName() : null;
        if (!pName) {
          var s = (typeof window !== 'undefined' && window.appStorage) || (typeof localStorage !== 'undefined' ? localStorage : null);
          try { pName = s ? s.getItem('cc_player_name') : null; } catch (_) {}
        }
        if (pName) {
          var nameInputs = document.querySelectorAll('#optPlayerName, .player-name-input');
          nameInputs.forEach(function(inp) {
            if (inp && inp.value !== pName) inp.value = pName;
          });
        }
        var avMgr = window.AvatarManager || (window.CrazyCribbage && window.CrazyCribbage.AvatarManager);
        if (avMgr && typeof avMgr.syncAvatarUI === 'function') {
          avMgr.syncAvatarUI();
        }
        if (typeof window.updateProfileDropdownUI === 'function') {
          window.updateProfileDropdownUI();
        }
      } catch (_) {}
    };

    window.updateBrandDropdownActive = function(brand) {
      var b = brand || window.currentLogoBrand || (window.detectBrand ? window.detectBrand() : 'crazy');
      var items = document.querySelectorAll('.brand-dropdown-item');
      if (!items || !items.length) return;
      items.forEach(function(item) {
        var itemBrand = item.getAttribute('data-brand');
        var isActive = itemBrand === b;
        item.classList.toggle('is-active', isActive);
        if (isActive) {
          item.setAttribute('aria-current', 'page');
        } else {
          item.removeAttribute('aria-current');
        }
      });
    };

    window.toggleBrandDropdown = function(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      var wrap = document.getElementById('brandDropdownWrap');
      var menu = document.getElementById('brandDropdownMenu');
      if (!menu || !wrap) return;
      var isOpen = wrap.classList.contains('is-open') || menu.classList.contains('is-open');
      if (isOpen) {
        window.closeBrandDropdown();
      } else {
        window.openBrandDropdown();
      }
    };

    window.openBrandDropdown = function() {
      if (typeof window.closeProfileDropdown === 'function') {
        window.closeProfileDropdown();
      }
      var wrap = document.getElementById('brandDropdownWrap');
      var menu = document.getElementById('brandDropdownMenu');
      var btn = document.getElementById('btnBrandMenu');
      if (!menu || !wrap) return;
      menu.classList.add('is-open');
      wrap.classList.add('is-open');
      if (btn) {
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('is-active');
      }
      if (typeof window.updateBrandDropdownActive === 'function') {
        window.updateBrandDropdownActive();
      }
    };

    window.closeBrandDropdown = function() {
      var wrap = document.getElementById('brandDropdownWrap');
      var menu = document.getElementById('brandDropdownMenu');
      var btn = document.getElementById('btnBrandMenu');
      if (wrap) wrap.removeAttribute('data-pinned');
      if (menu) menu.classList.remove('is-open');
      if (wrap) wrap.classList.remove('is-open');
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-active');
      }
    };

    window.toggleProfileDropdown = function(event) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      if (typeof window.showRecordsModal === 'function') {
        window.showRecordsModal();
      } else {
        var profileClass = window.Profile || (window.CrazyCribbage && window.CrazyCribbage.Profile);
        if (profileClass && typeof profileClass.showRecordsModal === 'function') {
          profileClass.showRecordsModal();
        }
      }
    };

    window.openProfileDropdown = function() {
      if (typeof window.showRecordsModal === 'function') {
        window.showRecordsModal();
      } else {
        var profileClass = window.Profile || (window.CrazyCribbage && window.CrazyCribbage.Profile);
        if (profileClass && typeof profileClass.showRecordsModal === 'function') {
          profileClass.showRecordsModal();
        }
      }
    };

    window.closeProfileDropdown = function() {
      var wrap = document.getElementById('profileDropdownWrap');
      var menu = document.getElementById('profileDropdownMenu');
      var btn = document.getElementById('btnRecords') || document.getElementById('btnProfileMenu');
      if (wrap) wrap.removeAttribute('data-pinned');
      if (menu) menu.classList.remove('is-open');
      if (wrap) wrap.classList.remove('is-open');
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-active');
      }
    };

    window.updateProfileDropdownUI = function() {
      var nameEl = document.getElementById('profileMenuPlayerName');
      var avatarNameEl = document.getElementById('profileMenuAvatarName');
      var avatarBadgeEl = document.getElementById('profileMenuAvatarBadge');
      var recordCountEl = document.getElementById('profileDropdownRecordCount');
      var winRateEl = document.getElementById('profileMenuWinRate');
      if (!nameEl && !avatarNameEl && !avatarBadgeEl && !recordCountEl && !winRateEl) return;

      var profileClass = window.Profile || (window.CrazyCribbage && window.CrazyCribbage.Profile);
      var profile = profileClass && typeof profileClass.getInstance === 'function' ? profileClass.getInstance() : null;

      var name = profile ? profile.getName() : ((document.getElementById('optPlayerName') && document.getElementById('optPlayerName').value.trim()) || 'Player');
      var avId = profile ? profile.getAvatar() : (window.AvatarManager && window.AvatarManager.getSelectedAvatarId ? window.AvatarManager.getSelectedAvatarId() : 'joker');
      var stats = profile ? (typeof profile.getOverallStats === 'function' ? profile.getOverallStats() : profile.getStats()) : { wins: 0, losses: 0, winRate: '0%' };
      var avMgr = window.AvatarManager || (window.CrazyCribbage && window.CrazyCribbage.AvatarManager);
      var avObj = avMgr && typeof avMgr.getAvatarById === 'function' ? avMgr.getAvatarById(avId) : null;

      if (nameEl) nameEl.textContent = name;
      if (avatarNameEl) avatarNameEl.textContent = avObj ? avObj.name : 'Persona';
      if (recordCountEl) recordCountEl.textContent = stats.wins + '–' + stats.losses;
      if (winRateEl) winRateEl.textContent = stats.winRate + ' Win';
      if (avatarBadgeEl) {
        if (avMgr && typeof avMgr.renderAvatarSvg === 'function') {
          avatarBadgeEl.innerHTML = avMgr.renderAvatarSvg(avId, { size: 28 });
        } else {
          avatarBadgeEl.textContent = '🎭';
        }
      }
    };

    window.handleProfileDropdownAction = function(action) {
      window.closeProfileDropdown();
      if (action === 'username') {
        var profileClass = window.Profile || (window.CrazyCribbage && window.CrazyCribbage.Profile);
        if (profileClass && typeof profileClass.promptChangeUsername === 'function') {
          profileClass.promptChangeUsername();
        } else {
          var current = (document.getElementById('optPlayerName') && document.getElementById('optPlayerName').value) || 'Player';
          var promptVal = window.prompt ? window.prompt('Enter your username:', current) : null;
          if (promptVal) {
            var sanitizedPrompt = typeof window.sanitizeUserInput === 'function' ? window.sanitizeUserInput(promptVal) : promptVal;
            var alphanumeric = sanitizedPrompt.replace(/[^a-zA-Z0-9]/g, '').trim().slice(0, 24);
            if (alphanumeric) {
              var inp = document.getElementById('optPlayerName');
              if (inp) inp.value = alphanumeric;
              try { localStorage.setItem('cc_player_name', alphanumeric); } catch (_) {}
              window.updateProfileDropdownUI();
            }
          }
        }
      } else if (action === 'avatar') {
        var avMgr = window.AvatarManager || (window.CrazyCribbage && window.CrazyCribbage.AvatarManager);
        if (avMgr && typeof avMgr.openAvatarModal === 'function') {
          avMgr.openAvatarModal();
        } else if (typeof window.openAvatarModal === 'function') {
          window.openAvatarModal();
        }
      } else if (action === 'records') {
        var profileClass = window.Profile || (window.CrazyCribbage && window.CrazyCribbage.Profile);
        if (profileClass && typeof profileClass.showRecordsModal === 'function') {
          profileClass.showRecordsModal();
        } else if (typeof window.showRecordsModal === 'function') {
          window.showRecordsModal();
        }
      }
    };

    window.updateBrowserUrlForBrand = function(targetBrand) {
      if (!targetBrand || typeof window === 'undefined') return;
      try {
        if (!window.history || typeof window.history.pushState !== 'function') return;

        var brandPagePaths = {
          crazy: '/pages/game-crazy-cribbage',
          clash: '/pages/game-cribbage-clash',
          pints: '/pages/game-pints-and-pegs',
          adult: '/pages/game-skunked-and-stripped'
        };

        var nextUrl;
        var pathname = window.location.pathname || '';
        if (pathname.startsWith('/pages/game-')) {
          nextUrl = brandPagePaths[targetBrand] || brandPagePaths.crazy;
          if (window.location.search) {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set('brand', targetBrand);
            searchParams.delete('game');
            searchParams.delete('logo');
            nextUrl += '?' + searchParams.toString();
          }
          if (window.location.hash) {
            nextUrl += window.location.hash;
          }
        } else {
          var urlObj = new URL(window.location.href);
          urlObj.searchParams.set('brand', targetBrand);
          urlObj.searchParams.delete('game');
          urlObj.searchParams.delete('logo');
          nextUrl = urlObj.pathname + urlObj.search + urlObj.hash;
        }

        var currentRelative = (window.location.pathname || '') + (window.location.search || '') + (window.location.hash || '');
        if (currentRelative !== nextUrl) {
          window.history.pushState({ brand: targetBrand }, '', nextUrl);
        }

        // Also try updating parent window if embedded in a same-origin frame
        try {
          if (window.parent && window.parent !== window && window.parent.history && typeof window.parent.history.pushState === 'function') {
            window.parent.history.pushState({ brand: targetBrand }, '', nextUrl);
          }
        } catch (pe) {}
      } catch (e) {
        console.warn('[BrandSwitcher] Could not update browser URL:', e);
      }
    };

    window.handleBrandLinkClick = function(event, targetBrand) {
      if (window.currentLogoBrand === targetBrand) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        window.closeBrandDropdown();
        return false;
      }

      var isLocal = window.location.protocol === 'file:' || 
                    window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' ||
                    !window.location.pathname.startsWith('/pages/game-');

      if (isLocal && typeof window.setLogoBrand === 'function') {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        window.setLogoBrand(targetBrand);
        window.updateBrowserUrlForBrand(targetBrand);
        window.closeBrandDropdown();
        return false;
      }

      window.updateBrowserUrlForBrand(targetBrand);
      window.closeBrandDropdown();
      return true;
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', function(e) {
        var detected = (window.detectBrand ? window.detectBrand() : null) || (e.state && e.state.brand);
        if (detected && detected !== window.currentLogoBrand && typeof window.setLogoBrand === 'function') {
          window.setLogoBrand(detected);
        }
      });
      window.addEventListener('avatar-changed', function() {
        if (typeof window.updateProfileDropdownUI === 'function') {
          window.updateProfileDropdownUI();
        }
      });
      window.addEventListener('profile-updated', function() {
        if (typeof window.updateProfileDropdownUI === 'function') {
          window.updateProfileDropdownUI();
        }
      });
    }

    if (typeof document !== 'undefined') {
      document.addEventListener('click', function(e) {
        var wrap = document.getElementById('brandDropdownWrap');
        if (wrap && !wrap.contains(e.target)) {
          window.closeBrandDropdown();
        }
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          window.closeBrandDropdown();
        }
      });

      // Synchronize player name globally whenever entered into #optPlayerName or .player-name-input
      document.addEventListener('input', function(e) {
        if (e.target && (e.target.id === 'optPlayerName' || (e.target.classList && e.target.classList.contains('player-name-input')))) {
          var rawVal = typeof window.sanitizeUserInput === 'function' ? window.sanitizeUserInput(e.target.value) : e.target.value;
          var filtered = rawVal.replace(/[^a-zA-Z0-9]/g, '');
          if (e.target.value !== filtered) {
            e.target.value = filtered;
          }
          var val = filtered.trim();
          if (val) {
            var profileClass = window.Profile || (window.CrazyCribbage && window.CrazyCribbage.Profile);
            var profile = profileClass && typeof profileClass.getInstance === 'function' ? profileClass.getInstance() : null;
            if (profile) {
              profile.setName(val);
            } else {
              try { localStorage.setItem('cc_player_name', val); } catch (_) {}
            }
            if (typeof window.updateProfileDropdownUI === 'function') {
              window.updateProfileDropdownUI();
            }
          }
        }
      });

      // Listen for profile-updated event to synchronize player name and avatar across all brand views
      window.addEventListener('profile-updated', function() {
        var profileClass = window.Profile || (window.CrazyCribbage && window.CrazyCribbage.Profile);
        var profile = profileClass && typeof profileClass.getInstance === 'function' ? profileClass.getInstance() : null;
        if (profile) {
          var curName = profile.getName();
          var nameInputs = document.querySelectorAll('#optPlayerName, .player-name-input');
          nameInputs.forEach(function(inp) {
            if (inp && inp.value !== curName) inp.value = curName;
          });
        }
        var avMgr = window.AvatarManager || (window.CrazyCribbage && window.CrazyCribbage.AvatarManager);
        if (avMgr && typeof avMgr.syncAvatarUI === 'function') {
          avMgr.syncAvatarUI();
        }
        if (typeof window.updateProfileDropdownUI === 'function') {
          window.updateProfileDropdownUI();
        }
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          if (typeof window.updateProfileDropdownUI === 'function') {
            window.updateProfileDropdownUI();
          }
        });
      } else {
        setTimeout(function() {
          if (typeof window.updateProfileDropdownUI === 'function') {
            window.updateProfileDropdownUI();
          }
        }, 100);
      }
    }

    var initialBrand = detectBrand();
    window.detectBrand = detectBrand;
    window.setLogoBrand(initialBrand);
  } catch (e) {}
})();
